<template>
  <v-row no-gutters dense class="saved-card" v-if="savedCard">
    <v-col cols="4">
      <h2>{{ savedCard.vendor }} ******{{ savedCard.last_four_digits }}</h2>
      <span v-if="savedCard.payment_type_id === 4">Saved via PayPal</span>
      <span v-if="savedCard.payment_type_id === 3">Saved via Stripe</span>
      <span v-if="savedCard.payment_type_id === 7">Saved credit card</span>
    </v-col>
    <v-col cols="4">
      <h2>{{ savedCard.expiry_month }}/{{ savedCard.expiry_year}}</h2>
    </v-col>
    <v-col cols="2">
      <v-btn x-small color="error" @click="removeCard"
             :loading="removeCardBtnLoading"
             :disabled="disabled || busy || removeCardBtnLoading">
        Remove
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'AirwallexSavedCards',
  mounted() {
    this.init().catch(() => {
      // The global API interceptor owns initial-load errors.
    });
  },
  beforeDestroy() {
    this.destroyed = true;
    this.activeRequests = 0;
    this.$emit('update:busy', false);
  },
  data() {
    return {
      savedCard: null,
      removeCardBtnLoading: false,
      activeRequests: 0,
      destroyed: false,
    };
  },
  methods: {
    beginRequest() {
      if (this.destroyed) {
        return false;
      }

      this.activeRequests += 1;
      this.$emit('update:busy', true);
      return true;
    },
    endRequest() {
      if (this.destroyed) {
        return;
      }

      this.activeRequests = Math.max(0, this.activeRequests - 1);
      this.$emit('update:busy', this.activeRequests > 0);
    },
    init() {
      if (!this.beginRequest()) {
        return Promise.resolve(null);
      }

      // No payment_type_id filter on purpose: once Airwallex is active,
      // PayPal/Stripe are hidden from the method list, so the card saved
      // on another module must stay visible (and chargeable) from here.
      const query = this.token ? `?token=${encodeURIComponent(this.token)}` : '';
      return this.$api.get(`partner/payment/get-saved-cards${query}`)
        .then((response) => {
          if (this.destroyed) {
            return null;
          }

          if (response.data !== '' && response.data !== null) {
            this.applySavedCard(response.data);
          } else {
            this.savedCard = null;
            this.$emit('update:card', null);
            this.$emit('update:hasCard', false);
          }

          return this.savedCard;
        })
        .finally(() => {
          this.endRequest();
        });
    },
    applySavedCard(savedCard) {
      if (this.destroyed) {
        return false;
      }

      this.savedCard = savedCard || null;
      this.$emit('update:card', this.savedCard);
      this.$emit('update:hasCard', !!this.savedCard);
      return true;
    },
    reinit() {
      if (this.destroyed) {
        return Promise.resolve(null);
      }

      this.savedCard = null;
      return this.init();
    },
    removeCard() {
      if (this.disabled || this.activeRequests > 0 || this.removeCardBtnLoading) {
        return null;
      }

      if (!this.beginRequest()) {
        return null;
      }

      this.removeCardBtnLoading = true;
      const postData = { id: this.savedCard.id };
      if (this.token) {
        postData.token = this.token;
      }
      return this.$api.post('partner/payment/remove-saved-card', postData)
        .then(() => {
          if (this.destroyed) {
            return null;
          }

          this.$emit('remove-card');
          return this.reinit();
        }).catch(() => {
          // The global API interceptor owns removal and refresh errors.
        }).finally(() => {
          if (this.destroyed) {
            return;
          }

          this.removeCardBtnLoading = false;
          this.endRequest();
        });
    },
  },
  props: {
    token: {
      type: String,
      default: '',
    },
    busy: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
  .saved-card {
    margin-bottom: 20px;
  }
</style>
